module.exports = __webpack_public_path__ + "img/extended.89b7e550.png";